import { getContactPageData, getFooterData, getHeaderData } from '@api/index'
import formWizard from '@fixtures/contact-form-wizard.json'

import Breadcrumb from '@/molecules/Breadcrumb'
import { DynamicForm, SectionBuilder } from '@/organisms'

import Layout from '@/organisms/Layout'

import useCustomDataLayerTracking, {
  DATA_LAYER_EVENT_NAMES,
  DATA_LAYER_KEY_NAMES,
} from '@hooks/useCustomDataLayerTracking'
import { default as normalizeBreadcrumb } from '@models/Breadcrumb'
import { default as normalizeFooterData } from '@models/Footer'
import { default as normalizeHeaderData } from '@models/Header'
import normalizeMetadata from '@models/Metadata'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

export const getStaticProps = async () => {
  const [footer, header, pageData] = await Promise.all([
    getFooterData(),
    getHeaderData(),
    getContactPageData(),
  ])

  return {
    props: {
      metadata: normalizeMetadata(pageData.seo),
      breadcrumb: normalizeBreadcrumb([{ label: 'Contatti' }]),
      header: normalizeHeaderData(header),
      footer: normalizeFooterData(footer),
      content: pageData,
      form: formWizard,
    },
  }
}

export default function ContactPage({
  metadata,
  breadcrumb,
  header,
  footer,
  content,
  form,
}) {
  const router = useRouter()
  const { dataLayer, handleDataLayerChange, triggerDataLayerEvent } =
    useCustomDataLayerTracking({
      keyName: DATA_LAYER_KEY_NAMES.formContacts,
      triggerEventName:
        DATA_LAYER_EVENT_NAMES.formContactsDataLayerEventTrigger,
      options: { prefixFormFields: form.options, formFields: {} },
    })
  const pathname = router.pathname

  useEffect(() => {
    if (pathname === '/contatti') {
      const startHandler = () => {
        const eventType = 'leavePage'
        triggerDataLayerEvent(dataLayer, eventType)
      }
      router.events.on('routeChangeStart', startHandler)
      return () => {
        router.events.off('routeChangeStart', startHandler)
      }
    }
  }, [dataLayer])

  return (
    <>
      <Layout
        metadata={metadata}
        headerData={header}
        footerData={footer}
      >
        <Breadcrumb items={breadcrumb} />
        <SectionBuilder data={content.sections} />
        <DynamicForm
          formData={form}
          dataLayer={dataLayer}
          triggerDataLayerEvent={triggerDataLayerEvent}
          onDataLayerChange={handleDataLayerChange}
        />
      </Layout>
    </>
  )
}
